import { CoatingCompatibilityBM } from 'src/types/BusinessModel/Stowage/Product/CoatingCompatibilityBM';
import { CoatingCompatibility } from 'src/types/ViewModel/Stowage/Product/CoatingCompatibility';

export const createProductCoatingCompatibility = (coatingCompatibilityBM: CoatingCompatibilityBM): CoatingCompatibility => {
    return {
        id: coatingCompatibilityBM.id,
        coatingId: coatingCompatibilityBM.coatingId,
        productId: coatingCompatibilityBM.productId,
        compatibility: coatingCompatibilityBM.compatibility,
        maxTemperature: coatingCompatibilityBM.maxTemperature,
        categoryId: coatingCompatibilityBM.categoryId,
        isCategoryLevel: coatingCompatibilityBM.isCategoryLevel,
    };
};

export const createProductCoatingCompatibilities = (list: CoatingCompatibilityBM[]) => list.map(createProductCoatingCompatibility);
